import React from 'react'
import Waste from './Waste'
const Increase = () => {
  return <Waste />
}
export default Increase
